export const refreshBrandGroupAfterAssignmentSave = async (
  refreshBrandGroup: () => Promise<unknown>,
): Promise<boolean> => {
  try {
    await refreshBrandGroup();
    return true;
  } catch (error) {
    console.warn(
      "[ConnectionAccessSettings] Failed to refresh integrations after Business-group assignment save",
      error,
    );
    return false;
  }
};
